import axios, { AxiosInstance } from 'axios';
import { setLogOut } from 'entities/auth';
import { BASE_URL } from '../conf/constants';
import { store } from '../../app/store';

const mainServiceWithCredentials: AxiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 3000000,
  headers: {},
});

mainServiceWithCredentials.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${store.getState().auth.token}`;

  return config;
});

mainServiceWithCredentials.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if ((error.response.status === 403 && !originalRequest._retry) || error.response.status === 401) {
      originalRequest._retry = true;
      const refreshResult = await fetch(`${BASE_URL}/account/admin/login/refresh-token`, {
        method: 'POST',
        headers: {
          Authorization: `Bearer ${localStorage.getItem('refresh_token')}`,
        },
      });
      if (refreshResult.status === 401) {
        store.dispatch(setLogOut());
      }
      if (refreshResult.status !== 403) {
        let access_token;
        (refreshResult as any).json().then((res: any) => {
          access_token = res.access_token;
          localStorage.setItem('access_token', res.access_token);
          localStorage.setItem('refresh_token', res.refresh_token);
        });
        axios.defaults.headers.common.Authorization = `Bearer ${access_token}`;
      }
      return mainServiceWithCredentials(originalRequest);
    }
    return Promise.reject(error);
  },
);

export { mainServiceWithCredentials };
